import React from "react";
import { useTranslation } from "react-i18next";
import { SELECTABLE_FLAG_CODES } from "assets/catalog";
import getPublicAssetUrl from "utils/PublicAsset";

const VISIBLE_ROWS = 3;
const FLAGS_PER_ROW = 8;

type FlagSelectorProps = {
    selectedFlag: string | null;
    onSelect: (flag: string) => void;
};

const FlagSelector = ({ selectedFlag, onSelect }: FlagSelectorProps) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = React.useState(false);
    const [optimisticFlag, setOptimisticFlag] = React.useState(selectedFlag);

    React.useEffect(() => { setOptimisticFlag(selectedFlag); }, [selectedFlag]);

    const visibleFlags = expanded ? SELECTABLE_FLAG_CODES : SELECTABLE_FLAG_CODES.slice(0, VISIBLE_ROWS * FLAGS_PER_ROW);

    return (
        <div>
            <h3 className="text-white font-changa-one text-base tracking-wide">{t("customize.flag_title")}</h3>
            <p className="text-white/50 text-sm mb-2">{t("customize.flag_subtitle")}</p>

            <div className="grid grid-cols-8 gap-1.5">
                {visibleFlags.map((flag) => (
                    <button
                        key={flag}
                        onClick={() => { setOptimisticFlag(flag); onSelect(flag); }}
                        className={`flex items-center justify-center rounded-lg p-1.5 transition-colors cursor-pointer ${
                            optimisticFlag === flag
                                ? "bg-white/15 ring-2 ring-amber-500/60"
                                : "bg-white/5 hover:bg-white/10"
                        }`}
                    >
                        <img src={getPublicAssetUrl(`assets/flags/${flag}.svg`)} alt={flag} className="w-6 h-4 object-contain" draggable={false} />
                    </button>
                ))}
            </div>

            {!expanded && SELECTABLE_FLAG_CODES.length > VISIBLE_ROWS * FLAGS_PER_ROW && (
                <button
                    onClick={() => setExpanded(true)}
                    className="w-full mt-2 py-1.5 text-white/40 text-xs font-semibold hover:text-white/60 transition-colors cursor-pointer"
                >
                    {t("customize.flag_show_more")}
                </button>
            )}
        </div>
    );
};

export default FlagSelector;
